module.exports = __webpack_public_path__ + "static/media/globallighting.afc27085.frag";